// Modules
import { useSession } from "next-auth/react";

/* eslint-disable react-hooks/rules-of-hooks */

/**
 * Gets the current user data.
 *
 * @returns the current user data
 */
export function getUserData() {
    const { data: session } = useSession();

    return session?.user;
}

/**
 * Gets the current user name.
 *
 * @returns the current user name
 */
export function getName() {
    const { data: session } = useSession();

    return session?.user?.name;
}

/**
 * Gets the current user id.
 *
 * @returns the current user id
 */
export function getId() {
    const { data: session } = useSession();

    return session?.user?._id;
}

/**
 * Gets the current user email.
 *
 * @returns the current user email
 */
export function getEmail() {
    const { data: session } = useSession();

    return session?.user?.email;
}

/**
 * Gets the current user role.
 *
 * @returns the current user role
 */
export function getRole() {
    const { data: session } = useSession();

    return session?.user?.role;
}

/**
 * Gets the current user therapist data.
 *
 * @returns the current user therapist data
 */
export function getTherapist() {
    const { data: session } = useSession();

    return session?.user?.therapist;
}

/**
 * Refreshes the current user session.
 *
 * @returns a function to update the current user session
 */
export const useRefreshSession = () => {
    const { update } = useSession();

    return update;
};
